import PartDetailComponent from 'src/components/features/superAdmin/partDetailComponent';

const DetailPartPage = () => <PartDetailComponent />;

export default DetailPartPage;
